import { render, staticRenderFns } from "./TkUpArrow.vue?vue&type=template&id=a3d4a59c&"
import script from "./TkUpArrow.vue?vue&type=script&lang=js&"
export * from "./TkUpArrow.vue?vue&type=script&lang=js&"
import style0 from "./TkUpArrow.vue?vue&type=style&index=0&id=a3d4a59c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports